import { Component, Input, Output, EventEmitter, ViewChild } from "@angular/core";

@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss']
})

export class ModalComponent {
    @Output() hidden = new EventEmitter();
    @ViewChild('modal') modal;
    constructor() { }
    show() {
        this.modal.nativeElement.style.display = "block";
    }
    hide() {
        this.modal.nativeElement.style.display = "none";
        this.hidden.emit();
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/shared/modal/modal.component.ts